import { DataProvider } from '@repo/ui/dataProvider'

import { Resources } from '@/components/admin/Resources'
import { SkeletonCard } from '@/components/skeletons/SkeletonCard'
import { RootState } from '@/store'

export function ResourcesRoute() {
  return (
    <DataProvider
      loadingComponent={<SkeletonCard />}
      selectors={[(state: RootState) => state.admin.resources]}
      render={(resources) => <Resources resources={resources} />}
    />
  )
}
